import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const PrivacyPolicy = () => {
  return (
    <main className="min-h-screen bg-background pt-24 pb-16">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-8">Política de Privacidad</h1>
          
          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p className="text-sm">Última actualización: {new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">1. Responsable del tratamiento</h2>
              <p>
                <strong>Identidad:</strong> Jon Quintano Fotografía<br />
                <strong>Dirección:</strong> Gamonal, 09007 Burgos, España<br />
                <strong>Email:</strong> info@jonquintano.com
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">2. Datos que recopilamos</h2>
              <p>Recopilamos los siguientes datos personales:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Formulario de contacto:</strong> nombre, email, asunto y mensaje.</li>
                <li><strong>Newsletter:</strong> dirección de email.</li>
                <li><strong>Área de clientes:</strong> nombre, email y contraseña (encriptada).</li>
                <li><strong>Datos de navegación:</strong> páginas visitadas, tiempo de permanencia (anónimos).</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">3. Finalidad del tratamiento</h2>
              <p>Utilizamos sus datos para:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Responder a sus consultas y solicitudes de información.</li>
                <li>Enviar comunicaciones comerciales si ha dado su consentimiento.</li>
                <li>Gestionar el acceso al área privada de clientes.</li>
                <li>Mejorar nuestros servicios mediante análisis de uso.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">4. Base legal</h2>
              <p>
                El tratamiento de sus datos se basa en su consentimiento expreso al enviar formularios,
                la ejecución de un contrato (servicios fotográficos) y nuestro interés legítimo en mejorar
                nuestros servicios.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">5. Conservación de datos</h2>
              <p>
                Conservaremos sus datos mientras exista una relación comercial o hasta que solicite su supresión.
                Los datos de contacto se conservan durante 2 años desde la última comunicación.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">6. Sus derechos</h2>
              <p>Puede ejercer los siguientes derechos:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Acceso:</strong> conocer qué datos tenemos sobre usted.</li>
                <li><strong>Rectificación:</strong> corregir datos inexactos.</li>
                <li><strong>Supresión:</strong> solicitar la eliminación de sus datos.</li>
                <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos.</li>
                <li><strong>Portabilidad:</strong> recibir sus datos en formato electrónico.</li>
              </ul>
              <p>Para ejercer estos derechos, contacte con nosotros en info@jonquintano.com</p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">7. Cookies</h2>
              <p>
                Este sitio web utiliza cookies técnicas necesarias para su funcionamiento.
                Puede configurar su navegador para rechazar cookies, aunque esto puede afectar
                a la funcionalidad del sitio.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">8. Seguridad</h2>
              <p>
                Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos
                contra acceso no autorizado, pérdida o destrucción.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
